








































import { Component, Mixins, Watch } from "vue-property-decorator";
import { Patient } from "../../../domain/patient";
import { PatientFinderMixin } from "./mixins";
import { IConfiguration } from "../../../domain/configuration";

@Component({
})
export default class PatientByIdFinder extends Mixins(PatientFinderMixin) {
  mounted() {
    this.focusToPatientId();
  }

  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient): void {
    if (!this.shouldConfirmFoundPatient) {
      // 患者情報確認しないで遷移する設定の場合
      if (!newValue) { return; }
      this.selectPatient();
      return;
    }

    // この時点ではselectButtonが見えてない.一瞬待ってから実行する.
    this.$nextTick(() => {
      this.focusToSelectButton();
    });
  }

  focusToPatientId(): void {
    const element = this.$refs.patientId as HTMLInputElement;
    element.focus();
    element.select();
  }

  focusToSelectButton(): void {
    const element = this.$refs.selectButton as HTMLElement;
    element.focus();
  }

  get shouldConfirmFoundPatient(): boolean {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.patient.finder.shouldConfirmFoundPatient;
  }
}
